import { __ } from "@wordpress/i18n";
import { useRulesContext } from "../../../../../hook/useRulesContext";
import { Save } from "lucide-react";

export default function ModalFooter() {
    const {
        editShortcodeData: shortcode,
        closeShortCodeModal,
        handleSubmit,
        loading,
    } = useRulesContext();

    return (
        <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between sticky bottom-0">
            <div className="text-sm text-gray-500">
                {__(
                    "* Required fields",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
            </div>
            <div className="flex items-center space-x-3">
                <button
                    type="button"
                    onClick={() => closeShortCodeModal()}
                    className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
                >
                    {__("Cancel", "wpbean-quantity-controls-for-woocommerce")}
                </button>
                <button
                    onClick={handleSubmit}
                    disabled={loading.formSubmit}
                    className="flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                    {loading.formSubmit ? (
                        <>
                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                            {__(
                                "Saving...",
                                "wpbean-quantity-controls-for-woocommerce",
                            )}
                        </>
                    ) : (
                        <>
                            <Save className="w-4 h-4 mr-2" />
                            {shortcode
                                ? __(
                                      "Update",
                                      "wpbean-quantity-controls-for-woocommerce",
                                  )
                                : __(
                                      "Create",
                                      "wpbean-quantity-controls-for-woocommerce",
                                  )}
                        </>
                    )}
                </button>
            </div>
        </div>
    );
}
